export default __webpack_public_path__ + "static/media/activate_segment.5eb1fd8b.png";